import CloseIcon from '@mui/icons-material/Close';
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    IconButton,
} from '@mui/material';
import React from 'react';
import { useSelector } from 'react-redux';
import { selectPriceRequired } from '../../../../../app/Slices/PriceRequiredSlice';
import { camelCaseToTitleCase } from '../../../../../shared/utils';
import { ModalProps } from '../../../../types/modal';

interface Props extends ModalProps {
    onChange: () => any;
    experienceType: string;
    priceRequired?: { spaceType?: string }[];
    action?: 'save' | 'publish';
}

const SaveExperienceConfirmationModal = ({
    onChange,
    open,
    onClose,
    experienceType,
    priceRequired: priceRequiredProp,
    action = 'save',
}: Props) => {
    const priceRequiredFromStore = useSelector(selectPriceRequired);
    const priceRequired = priceRequiredProp ?? priceRequiredFromStore;

    const experienceTypeText =
        experienceType === 'commercial'
            ? priceRequired?.length > 1
                ? priceRequired
                      .slice(0, -1)
                      .map((space) => camelCaseToTitleCase(space.spaceType))
                      .join(', ') +
                  ' and ' +
                  camelCaseToTitleCase(
                      priceRequired[priceRequired.length - 1]?.spaceType || '',
                  )
                : priceRequired
                      .map((space) =>
                          camelCaseToTitleCase(space?.spaceType || ''),
                      )
                      .join('')
            : `the ${experienceType}`;

    return (
        <Dialog open={open} onClose={onClose} maxWidth='sm' fullWidth>
            <DialogTitle>
                Save experience
                <IconButton
                    onClick={onClose}
                    size='small'
                    aria-label='close'
                    sx={{ color: 'text.primary' }}
                >
                    <CloseIcon />
                </IconButton>
            </DialogTitle>
            <DialogContent>
                <DialogContentText
                    sx={{
                        fontWeight: 600,
                        color: 'text.primary',
                        fontSize: '14px',
                    }}
                >
                    {`You haven't entered a price for ${experienceTypeText}. Are you sure you want to ${action} the experience?`}
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>Cancel</Button>
                <Button variant='contained' onClick={onChange}>
                    Yes
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default SaveExperienceConfirmationModal;
